export const VAC_OPTIONS = [
  { value: '1', label: 'Conventional' },
  { value: '101', label: 'Genadyne' },
  { value: '105', label: 'KCI' },
  { value: '104', label: 'Smith&Nephew' },
  { value: '7', label: 'Vertice' },
]

export const HOME_OPTIONS = [
  { value: '1', label: 'Home' },
  { value: '2', label: 'Clinic' },
  { value: '3', label: 'Hospital' },
  { value: '4', label: 'Other' },
]

export const getHomeLabel = (value) => {
  const option = HOME_OPTIONS.find((item) => item.value === value)
  return option ? option.label : 'error'
}

export const getVacLabel = (value) => {
  const option = VAC_OPTIONS.find((item) => item.value === value)
  return option ? option.label : 'error'
}